import React from "react";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import {auth,storage,db} from "../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { doc, setDoc } from "firebase/firestore";
import { useNavigate,Link } from "react-router-dom";

const Register=()=>{
    const navigate=useNavigate();

    const handlesub=async(e)=>{
        e.preventDefault()
        const displayName=e.target[0].value;
        const email=e.target[1].value;
        const password=e.target[2].value;
        const file=e.target[3].files[0];
        try{
    const res=await createUserWithEmailAndPassword(auth, email, password);


const storageRef = ref(storage, displayName);

const uploadTask = uploadBytesResumable(storageRef, file);

uploadTask.on(
  (error) => {
    console.log(error);
  }, 
  () => {
    getDownloadURL(uploadTask.snapshot.ref).then(async(downloadURL) => {
      await updateProfile(res.user,{
        displayName,
        photoURL:downloadURL,
      });
      await setDoc(doc(db, "users", res.user.uid), {
        uid:res.user.uid,
        displayName:displayName,
        email:email,
        photoURL:downloadURL
      });
      await setDoc(doc(db,"userchats",res.user.uid),{});
      navigate("/");
   
});
  }
);

        }catch(error){
            console.log(error);
            alert(error);
        }
}
    
    return(
        <div className="formContainer">
            <div className="formWrapper">
                <span className="logo">Quick Chat</span>
                <span className="title">Register</span>
                <form onSubmit={handlesub}>
                    <input type="text" placeholder="Display Name"/>
                    <input type="text" placeholder="Email" />
                    <input type="text" placeholder="Password" />
                    <input style={{display:"none"}} type="file" id="file" />
                    <label htmlFor="file">
                        <img src="im.png" alt="" />
                        <span>Add a Avatar</span>
                    </label>
                    <button type="submit">Signup</button>
                </form>
                <p>Already have an account? <Link to={"/login"}>Sign in</Link></p>
            </div>
        </div>
    )
}

export default Register